import React, { Component } from "react";
import { Row, Col, Card, Button, Container, Form, Accordion, RowToggleDataTable } from "react-bootstrap";
import AddBuildingModal from "./AddBuildingModal";
import "./_hostelAttendance.scss"
import SelectDropDown from '../selectdropdown/SelectDropDown';
import { components } from 'react-select';
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import * as compose from "lodash.flowright";
import { withApollo } from "react-apollo";
import { withRouter } from "react-router-dom";
import MultiSelect from "react-multi-select-component";

class HostelRoomAttendanceSection extends Component {
  constructor(props) {
    super();
    // this.handleBranchSubmit=this.handleBranchSubmit.bind(this);
    this.state = {
      branchSearch: "",
      branchError: "",

      addBuildingModal: false,

      activeBuildingDetails: null,
      activeFloorDetails: null,
      activeRoomDetails: null,
      activeCapacityDetails: null,
      getBuildingData: [],
      getFloorData: [],
      getRoomData: [],
      getStudentData: [],
      loading: 0,
      noDateError: "",
      isEdit: false
    }
  }
  handleBranchChange = (e) => {
    let name = e.target.name
    let value = e.target.value
    if (name == "branch") {
      this.setState({
        branchSearch: value,
        branchError: "",
        getBuildingData: [],
        loading: 0,
        noDateError: ""
      })

    }
  }

  getBuildingCreationDetails = async () => {
    const result = await this.props.client.query({
      query: gql`
                query($institute_id: Int!, $branch_id: Int!){
                    getBuildingCreationDetails(institute_id: $institute_id, branch_id:$branch_id) {
                        hostel_building_id
                        hostel_building_name
                        floors_details{
                          floor_id
                          floor_name
                          rooms_details{
                            room_id
                            room_name
                            room_capacity
                            capacity_details{
                              edu_student_id
                            }
                          }
                        }
                    }
                }
                `,
      variables: {
        institute_id: parseInt(Cookies.get("institutionid")),
        branch_id: parseInt(this.state.branchSearch)
      },
      fetchPolicy: 'network-only'
    })
    console.log("ss", result.data.getBuildingCreationDetails);
    if (result.data.getBuildingCreationDetails.length > 0) {
      let filter_data = result.data.getBuildingCreationDetails
      this.setState({
        getBuildingData: filter_data,
        loading: 0
      })

    } else {
      this.setState({ loading: 0, getBuildingData: [], noDateError: "No Data Available" })

    }
  }

  handleAccordionClick1 = (item, name, isEdit) => {

    console.log("item", item);

    if (name == "building") {
      if (this.state.activeBuildingDetails == item.hostel_building_id) {
        this.setState({ activeBuildingDetails: null, activeFloorDetails: null, activeRoomDetails: null, activeCapacityDetails: null, getFloorData: [], getRoomData: [], getStudentData: [] });
      } else if (this.state.activeBuildingDetails != null && this.state.activeBuildingDetails != item.hostel_building_id) {
        const floorData = this.state.getBuildingData.filter((a) => a.hostel_building_id === item.hostel_building_id)[0].floors_details;
        this.setState({ activeBuildingDetails: item.hostel_building_id, activeFloorDetails: null, activeRoomDetails: null, activeCapacityDetails: null, getFloorData: floorData, getRoomData: [], getStudentData: [] });
      } else {
        const floorData = this.state.getBuildingData.filter((a) => a.hostel_building_id === item.hostel_building_id)[0].floors_details;
        this.setState({ activeBuildingDetails: item.hostel_building_id, getFloorData: floorData });
      }
    }


    if (name == "floor") {

      if (this.state.activeFloorDetails === item) {
        this.setState({ activeFloorDetails: null, activeRoomDetails: null, activeCapacityDetails: null, getRoomData: [], getStudentData: [] });
      } else {

        const roomData = this.state.getFloorData.filter((a) => a.floor_id === item)[0].rooms_details;
        this.setState({ activeFloorDetails: item, getRoomData: roomData });
      }
    }

    if (name == "room") {


      console.log("state", this.state.isEdit);
      if (this.state.activeRoomDetails === item.room_id && !isEdit) {
        this.setState({ activeRoomDetails: null, activeCapacityDetails: null, getStudentData: [] });
      } else {
        const studentData = this.state.getRoomData.filter((a) => a.room_id === item.room_id)[0].capacity_details;
        let capacityDetails = [];

        if (studentData.length > 0) {
          capacityDetails = studentData.filter((item, index, array) => {
            return array.findIndex((obj) => obj.edu_student_id == item.edu_student_id) === index
          })
        }
        this.setState({ activeRoomDetails: item.room_id, getStudentData: capacityDetails, activeCapacityDetails: item.room_capacity });
      }
    }

  };

  handleBranchSubmit = (e) => {
    console.log("gege", e);
    e.preventDefault();
    if (this.state.branchSearch == "") {
      this.setState({ branchError: "Please select Branch" })
      return ""
    }
    this.setState({ loading: 1 })
    this.getBuildingCreationDetails();
  }





  //   componentDidMount(){
  //     let e = {
  //         preventDefault: function () {

  //         }
  //     }

  //     setTimeout(() => {
  //         this.handleBranchSubmit(e)

  //     }, 100)
  // }



  render() {
    console.log("oooo121o", this.state);

    if (this.props.studentCreationModal) {
      this.state.addBuildingModal = true
    }
    return (
      <Container>
        <Row className="mt-4">
          <Col sm={12}>
            <Form.Group style={{ display: "flex", justifyContent: "end", marginBottom: "-13px" }}>
              <button className="student_Allocation h6" onClick={() => this.setState({ addBuildingModal: true })}>Student Allocation</button>
            </Form.Group>
          </Col>
        </Row>

        {/* <hr className="bg-dark"/> */}

        <Row className="mt-2">
          <Col sm={12}>
            <Form>
              <Form.Row>
                <Form.Group as={Col} lg={2} md={12} sm={12} controlId="SelectBranchName">
                  <Form.Label className="text-uppercase font-weight-bold">Select Branch</Form.Label>
                  <Form.Control as="select" name="branch" onChange={this.handleBranchChange} value={this.state.branchSearch}>
                    <option value="">--Select Branch--</option>
                    {this.props.globals.globalBranches.map(branchData => (
                      <option value={branchData.id}>{branchData.branch_name}</option>
                    ))}
                  </Form.Control>
                  <Form.Text className="form-text text-danger">
                    {this.state.branchError}
                  </Form.Text>
                </Form.Group>
                <Form.Group as={Col} lg={2} md={12} sm={12} controlId="SelectBranch">
                <button className="btn  text-uppercase submit_btn btn-color-1" onClick={this.handleBranchSubmit}>
                    Submit</button>
                </Form.Group>
              </Form.Row>
            </Form>
          </Col>
        </Row>
        {
          this.state.getBuildingData.length > 0 ? (
            <>
              <Card style={{ backgroundColor: "#f8f9fa", cursor: "pointer", border: "none" }}>
                <Card.Body>
                  <Card>
                    <Accordion >
                      {this.state.getBuildingData.map((item, index) => {

                        console.log("itemsss", item);
                        return (
                          <Card >
                            <Accordion.Toggle
                              className="building_bg student_building_bg"
                              as={Card.Header}
                              eventKey={index.toString()}
                              onClick={() => this.handleAccordionClick1(item, "building")}
                            >

                              <Row>
                                <Col xl={1} lg={1} md={1} sm={2} xs={2}>
                                  {this.state.activeBuildingDetails === item.hostel_building_id ?
                                    <i className="fa-fw far fa-minus-square" style={{ cursor: "pointer" }}></i>
                                    :
                                    <i className="fa-fw far fa-plus-square" style={{ cursor: "pointer" }}></i>
                                  }
                                </Col>
                                <Col lg={2} md={1} sm={2}>
                                  <div>{item.hostel_building_name}</div></Col>
                                <Col lg={2} md={1} sm={2}> <div>Floors : {item.floors_details.length}</div></Col>
                                <Col lg={2} md={1} sm={2}>
                                  <div>Rooms : {
                                    item.floors_details.reduce((totalRooms, floor) => {
                                      return totalRooms + (floor.rooms_details ? floor.rooms_details.length : 0);
                                    }, 0)
                                  }</div>
                                </Col>
                                <Col lg={2} md={1} sm={2}>
                                  <div>Capacity : {
                                    item.floors_details.reduce((totalCapacity, floor) => {
                                      return totalCapacity + (floor.rooms_details ? floor.rooms_details.reduce((roomCapacity, room) => {
                                        return roomCapacity + (room.room_capacity ? room.room_capacity : 0);
                                      }, 0) : 0);
                                    }, 0)
                                  }</div>
                                </Col>
                                <Col lg={1} md={1} sm={2}>
                                  <div style={{ marginLeft: "-28px" }}>Filled : {
                                    item.floors_details.reduce((totalStudents, floor) => {
                                      return totalStudents + (floor.rooms_details ? floor.rooms_details.reduce((roomStudents, room) => {
                                        let capacityDetails = [];

                                        if (room.capacity_details.length > 0) {
                                          capacityDetails = room.capacity_details.filter((item, index, array) => {
                                            return array.findIndex((obj) => obj.edu_student_id == item.edu_student_id) === index
                                          })
                                        }
                                        const filledStudents = capacityDetails.length;
                                        return roomStudents + filledStudents;
                                      }, 0) : 0);
                                    }, 0)
                                  }</div>
                                </Col>
                                <Col lg={2} md={1} sm={2}>
                                  <div>Vacancies : {
                                    item.floors_details.reduce((totalCapacity, floor) => {
                                      return totalCapacity + (floor.rooms_details ? floor.rooms_details.reduce((roomCapacity, room) => {
                                        return roomCapacity + (room.room_capacity ? room.room_capacity : 0);
                                      }, 0) : 0);
                                    }, 0) -
                                    item.floors_details.reduce((totalStudents, floor) => {
                                      return totalStudents + (floor.rooms_details ? floor.rooms_details.reduce((roomStudents, room) => {
                                        let capacityDetails = [];

                                        if (room.capacity_details.length > 0) {
                                          capacityDetails = room.capacity_details.filter((item, index, array) => {
                                            return array.findIndex((obj) => obj.edu_student_id == item.edu_student_id) === index
                                          })
                                        }
                                        const filledStudents = capacityDetails.length;
                                        return roomStudents + filledStudents;
                                      }, 0) : 0);
                                    }, 0)
                                  }</div>
                                </Col>
                              </Row>
                            </Accordion.Toggle>

                            <Accordion.Collapse eventKey={index.toString()}>
                              <Card.Body className="building_bg student_building_bg">

                                {
                                  item.hostel_building_id == this.state.activeBuildingDetails ? (
                                    item.floors_details.map((floor, floorIndex) => (

                                      <Accordion activeKey={this.state.activeFloorDetails}>
                                        <Card>
                                          <Accordion.Toggle
                                            className="floor_bg student_floor_bg"
                                            as={Card.Header}
                                            eventKey={floor.floor_id}
                                            onClick={() => this.handleAccordionClick1(floor.floor_id, "floor")}
                                          >
                                            <Row>
                                              <Col xl={1} lg={1} md={1} sm={2} xs={2}>
                                                {this.state.activeFloorDetails === floor.floor_id ? (
                                                  <i className="fa-fw far fa-minus-square" style={{ cursor: "pointer" }}></i>
                                                ) : (
                                                  <i className="fa-fw far fa-plus-square" style={{ cursor: "pointer" }}></i>
                                                )}
                                              </Col>
                                              <Col xl={11} lg={11} md={11} sm={10} xs={10} className="d-flex justify-content-between">
                                                <div>{floor.floor_name}</div>
                                                <div style={{ marginLeft: "-36px" }}>Rooms : {floor.rooms_details.length}</div>
                                                <div>Room Capacity : {
                                                  floor.rooms_details.reduce((totalCapacity, room) => {
                                                    return totalCapacity + (room.room_capacity ? room.room_capacity : 0);
                                                  }, 0)
                                                }</div>
                                                <div>Filled : {
                                                  floor.rooms_details.reduce((totalfilled, room) => {
                                                    let capacityDetails = [];

                                                    if (room.capacity_details.length > 0) {
                                                      capacityDetails = room.capacity_details.filter((item, index, array) => {
                                                        return array.findIndex((obj) => obj.edu_student_id == item.edu_student_id) === index
                                                      })
                                                    } const filledStudents = capacityDetails.length
                                                    return totalfilled + filledStudents
                                                  }, 0)
                                                }</div>
                                                <div>Vacancies : {
                                                  floor.rooms_details.reduce((totalCapacity, room) => {
                                                    return totalCapacity + (room.room_capacity ? room.room_capacity : 0);
                                                  }, 0) -
                                                  floor.rooms_details.reduce((totalfilled, room) => {
                                                    let capacityDetails = [];

                                                    if (room.capacity_details.length > 0) {
                                                      capacityDetails = room.capacity_details.filter((item, index, array) => {
                                                        return array.findIndex((obj) => obj.edu_student_id == item.edu_student_id) === index
                                                      })
                                                    } const filledStudents = capacityDetails.length
                                                    return totalfilled + filledStudents
                                                  }, 0)
                                                }</div>
                                              </Col>
                                            </Row>
                                          </Accordion.Toggle>
                                          {
                                            this.state.activeFloorDetails == floor.floor_id ? (
                                              <Accordion.Collapse eventKey={floor.floor_id}>
                                                <Card.Body className="floor_bg student_floor_bg">
                                                  {floor.rooms_details.map((room, roomIndex) => {
                                                    let popupshow = false;
                                                    let uniqCapacityDetails = room.capacity_details.filter((item, index, array) => {
                                                      return array.findIndex((obj) => obj.edu_student_id == item.edu_student_id) === index
                                                    })
                                                    console.log("uniqCapacityDetails", uniqCapacityDetails);
                                                    return (
                                                      <Accordion activeKey={this.state.activeRoomDetails}>
                                                        <Card>
                                                          <Accordion.Toggle
                                                            className="room_bg student_room_bg"
                                                            as={Card.Header}
                                                            eventKey={room.room_id}
                                                            onClick={() => this.handleAccordionClick1(room, "room", popupshow)}
                                                          >
                                                            <Row>
                                                              <Col xl={1} lg={1} md={1} sm={2} xs={2}>
                                                                {this.state.activeRoomDetails === room.room_id ? (
                                                                  <i className="fa-fw far fa-minus-square" style={{ cursor: "pointer" }}></i>
                                                                ) : (
                                                                  <i className="fa-fw far fa-plus-square" style={{ cursor: "pointer" }}></i>
                                                                )}
                                                              </Col>
                                                              <Col xl={11} lg={11} md={11} sm={10} xs={10} className="d-flex justify-content-between">
                                                                <div>{room.room_name}</div>
                                                                <div>Room Capacity : {room.room_capacity}</div>
                                                                <div>Filled : {uniqCapacityDetails ? uniqCapacityDetails.length : 0}</div>
                                                                <div>Vacancies : {
                                                                  (room.room_capacity) - (uniqCapacityDetails ? uniqCapacityDetails.length : 0)
                                                                }</div>


                                                                <div onClick={() => {
                                                                  this.setState({ addBuildingModal: true, isEdit: true });
                                                                  popupshow = true;
                                                                }}>
                                                                  <Button variant="link" name="edit" className="text-dark mb-2">
                                                                    <i className="far fa-edit" />
                                                                  </Button>
                                                                </div>

                                                              </Col>
                                                            </Row>
                                                          </Accordion.Toggle>
                                                          <Accordion.Collapse eventKey={room.room_id} >
                                                            <Card.Body className="student_bg" >
                                                              <Card className="student_bg text-dark" style={{ border: "rgb(112,128,144)" }}>
                                                                <Row>
                                                                  {uniqCapacityDetails.length > 0 ? (
                                                                    uniqCapacityDetails.map((capacity) => {

                                                                      let studentData = this.props.getNewEducationalStudents.find((student) => student.student_id == capacity.edu_student_id)
                                                                      console.log("studentData", studentData.student_name, studentData);
                                                                      return (
                                                                        <Col lg={3} >
                                                                          <div className="mt-1">
                                                                            <span>
                                                                              {studentData.student_name} ({studentData.roll_no})
                                                                            </span>
                                                                          </div>
                                                                        </Col>
                                                                      )
                                                                    }


                                                                    )
                                                                  ) : (
                                                                    <Col lg={12}>
                                                                      <div className="mt-1 text-center">Please allocate students</div>
                                                                    </Col>
                                                                  )}
                                                                </Row>
                                                              </Card>

                                                            </Card.Body>
                                                          </Accordion.Collapse>

                                                        </Card>
                                                      </Accordion>
                                                    )
                                                  }
                                                  )}
                                                </Card.Body>
                                              </Accordion.Collapse>

                                            ) : ("")
                                          }

                                        </Card>
                                      </Accordion>
                                    ))
                                  ) : ("")
                                }

                              </Card.Body>
                            </Accordion.Collapse>
                          </Card>
                        );
                      })}
                    </Accordion>
                  </Card>
                </Card.Body>
              </Card>
            </>
          ) : (
            <Row>
              {
                <>
                  <Col sm={12}>
                    <div className={this.state.loading == 1 ? "d-flex align-items-center spinner-border text-primary text-center loading-img-center" : ""}></div>
                  </Col>
                  <Col sm={12}>
                    {
                      this.state.noDateError != "" ?
                        (
                          <h6 className='d-flex justify-content-center align-content-center'>{this.state.noDateError}</h6>
                        )
                        :
                        ("")
                    }
                  </Col>
                </>
              }
            </Row>
          )}

        <AddBuildingModal
          globals={this.props.globals}
          getNewEducationalStudents={this.props.getNewEducationalStudents}
          stateData={this.state}
          show={this.state.addBuildingModal}
          onHide={() => this.setState({ addBuildingModal: false, isEdit: false, activeRoomDetails: null, })}
        />
      </Container>
    )
  }
}
export default withRouter(withApollo(
  (HostelRoomAttendanceSection))
);